import { Header } from 'components/Header'
import { Layout } from 'components/Layout'
import { Footer } from 'components/Footer'
import { BreadCrumbs } from 'components/BreadCrumbs'
import { TranslationKeys } from 'locales/translationKeys'
import { FreezeDriedRawNuggetsRoot, BreadCrumbWrapper } from './FreezeDriedRawNuggets.styles'
import { PurchaseHero } from './components/PurchaseHero'
import { QualityIngredients } from './components/QualityIngredients'
import { ProductDetails } from './components/ProductDetails'
import { WhyFreezeDriedRaw } from './components/WhyFreezeDriedRaw'
import { VetQuote } from './components/VetQuote'
import { RealResults } from 'features/Home/components/RealResults'
import { ScoopServeBanner } from './components/ScoopServeBanner'
import { FAQ } from './components/FAQ'
import { CtaBanner } from './components/CtaBanner'
import { useFetchProductVariants } from 'features/ECommerce/api/queries/useFetchProductVariants'
import { useAddToCart } from 'features/ECommerce/hooks/useAddToCart'
import { Loader } from 'features/components/Loader'
import { useScrollToTop } from 'hooks/useScrollToTop'
import { useObserver } from 'hooks/useObserver'
import { useEffect } from 'react'

const crumbs: TranslationKeys[] = [
  'products-v2:freeze-dried-raw-nuggets.purchase-hero.breadcrumb-products',
  'products-v2:freeze-dried-raw-nuggets.purchase-hero.breadcrumb-freeze-dried-box',
]

export const FreezeDriedRawNuggets = () => {
  const header = <Header />
  const addToCart = useAddToCart()
  const scrollToTop = useScrollToTop()
  const selector = 'button.cta'

  const { data: response, status } = useFetchProductVariants({
    page: 1,
    limit: 10,
    textSearch: 'The Raw To-Go Box',
  })

  const hideCta = useObserver({ selector, isLoading: status === 'loading' })


  if (status === 'loading' || status === 'idle' || status === 'error') return <Loader />

  return (
    <FreezeDriedRawNuggetsRoot>
      <Layout hideCTA={hideCta} CTA={{ text: 'products-v2:freeze-dried-raw-nuggets.cta-banner.cta', onCtaClick: () => scrollToTop('smooth'), url: '#hero'}}
       header={header}>
        <BreadCrumbWrapper>
          <BreadCrumbs crumbs={crumbs} />
        </BreadCrumbWrapper>
        <PurchaseHero onAdd={addToCart} products={response.productVariants} />
        <QualityIngredients />
        <ProductDetails />
        <WhyFreezeDriedRaw />
        <VetQuote />
        <RealResults cta="products-v2:freeze-dried-raw-nuggets.cta-banner.cta" onCtaClick={() => scrollToTop('smooth')} />
        <ScoopServeBanner />
        <FAQ />
        <CtaBanner />
        <Footer />
      </Layout>
    </FreezeDriedRawNuggetsRoot>
  )
}

FreezeDriedRawNuggets.displayName = 'FreezeDriedRawNuggets'
